import { render, staticRenderFns } from "./ListaTurnos.vue?vue&type=template&id=095295e9&"
import script from "./ListaTurnos.vue?vue&type=script&lang=js&"
export * from "./ListaTurnos.vue?vue&type=script&lang=js&"
import style0 from "./ListaTurnos.vue?vue&type=style&index=0&id=095295e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports